import { Badge as ChakraBage } from "@chakra-ui/react"
import styled from "@emotion/styled"

export const StyledChakraBage = styled(ChakraBage)`
  background: #046cec;
  padding: 8px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`
